/* global define CustomersCanvas */
import DesignLayout from 'records/DesignLayout';
import { updateDesignParameter, updateDesignSavedState } from 'actions/designParameter';
import { getDesignLayoutsAsync } from 'actions/designLayouts';

export const CANVAS_LOAD_START = 'CANVAS_LOAD_START';
export const CANVAS_LOAD_ERROR = 'CANVAS_LOAD_ERROR';
export const CANVAS_LOAD_SUCCESS = 'CANVAS_LOAD_SUCCESS';
export const CANVAS_RESET_STATE = 'CANVAS_RESET_STATE';

try {
  CustomersCanvas.Utils.Ajax.request = function (parameters) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(parameters.type, parameters.url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Accept', '*/*');
      if (parameters.headers != null) {
        for (let i = 0, a = parameters.headers; i < a.length; i++) {
          const header = a[i];
          xhr.setRequestHeader(header.name, header.value);
        }
      }
      xhr.send(parameters.data);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        const status = xhr.status;
        const response = {
          value: xhr.responseText,
          status,
          contentType: xhr.getResponseHeader('content-type'),
          xhr,
        };
        if (status >= 200 && status < 300) {
          resolve(response);
        } else {
          reject(new CustomersCanvas.AjaxResponseException(response));
        }
      };
    });
  };
} catch (err) {
  // TODO: Handle this error scenario
  // by changing a state to enable an error message (can use maintenance window implementation)
  console.log("ERROR: ", err);
}

function canvasLoadStart() {
  return {
    type: CANVAS_LOAD_START,
  };
}

function canvasLoadError(error) {
  return {
    type: CANVAS_LOAD_ERROR,
    error,
  };
}

function canvasLoadSuccess(data) {
  return {
    type: CANVAS_LOAD_SUCCESS,
    data,
  };
}

export function resetCanvasState() {
  return {
    type: CANVAS_RESET_STATE,
  };
}

export function intializeIframeApi(domElement, productDefinition, configuration) {
  return (dispatch, getState) => {

    dispatch(canvasLoadStart());
    return CustomersCanvas.IframeApi.loadEditor(domElement, productDefinition, configuration)
    .then((editor) => {
      editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.OnSurfaceChanged,
        function(args){
          editor.getProduct()
          .then(function(product) {
            const design = getState().design.get('data');
            const designParameter = getState().designParameter.get('data');
            const layoutElementsList = DesignLayout.getLayoutSubstringContentName(design, designParameter.get('currentDesignPageIndex'));

            const surfaces = product.surfaces;
            let indicator = -1;

            surfaces.forEach((page, index) => {
              if(page.id === args && args === product.currentSurface.id) {
                indicator = index;
              }
            });

            if(indicator >= 0 ) {
              let newParas = designParameter.set('currentDesignPageIndex', indicator);
              newParas = newParas.set('isSwitchFromCC', true);

              //only for CC switch, not from layout switch page
              if(designParameter.get('isSwitchFromCC')) {
                const { typeId, sizeId, designTextVer } = DesignLayout.getLayoutSubstringContentName(design, indicator);
                if(layoutElementsList.typeId != typeId || layoutElementsList.sizeId != sizeId || layoutElementsList.designTextVer != designTextVer){
                    dispatch(getDesignLayoutsAsync(typeId, sizeId, designTextVer));
                }
              }
              dispatch(updateDesignParameter(newParas));
            }
          });
        });
      // Subcribe events Ref: https://customerscanvas.com/docs/cc/customerscanvas.iframeapi.postmessage.events.htm
      editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.ItemAdded, () => dispatch(updateDesignSavedState(true)));
      editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.ItemChanged, () => dispatch(updateDesignSavedState(true)));
      editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.ItemRemoved, () => dispatch(updateDesignSavedState(true)));
      editor.subscribe(CustomersCanvas.IframeApi.PostMessage.Events.RevertProduct, () => dispatch(updateDesignSavedState(true)));
      dispatch(canvasLoadSuccess({
        domElement,
        productDefinition,
        configuration,
      }));
      return editor;
    })
    .catch((error) => {
      dispatch(canvasLoadError(error));
    });
  };
}
